import { RouteLocationRaw } from "vue-router"
import { useAcl } from "vue-simple-acl"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  if (!useAcl().can.any("canReviewTimesheet")) {
    return next({
      name: "Error",
      query: {
        code: 404
      }
    })
  }

  next()
}
